import { ThemeProvider } from "@mui/material/styles";
import { LanguageContextProvider } from "components/LanguageContext";
import FocusOnScroll from "components/LayoutFront/FocusOnScroll";
import LayoutFront from "components/LayoutFront/LayoutFront";
import MessageContext from "components/MessageContext";
import PageSwitcher from "components/PageSwitcher";
import { PageVersionContextProvider } from "components/PageVersionContext";
import { PaginationContextProvider } from "components/PaginationContext";
import ResultsSearch from "components/ResultsSearch";
import SiteContext from "components/SiteContext";
import Snackbar from "components/Snackbar";
import React, { useCallback, useContext, useMemo, useReducer } from "react";
import { Route, Switch } from "react-router-dom";
import themes from "./themes/themes";

const messageTypes = {
  SUCCESS: "SUCCESS",
  WARNING: "WARNING",
  ERROR: "ERROR",
};

const snackbarReducer = (snackbarState, action) => {
  const { type, message } = action || {};
  switch (type) {
    case messageTypes.SUCCESS:
      return {
        open: true,
        variant: "success",
        message,
      };
    case messageTypes.WARNING:
      return {
        open: true,
        variant: "warning",
        message,
      };
    case messageTypes.ERROR:
      return {
        open: true,
        duration: null,
        variant: "error",
        message,
      };
    default:
      return {
        ...snackbarState,
        open: false,
      };
  }
};

const App = () => {
  const site = useContext(SiteContext);

  const [snackbar, dispatch] = useReducer(snackbarReducer, { open: false });

  const displaySuccess = useCallback((message) => {
    dispatch({ type: messageTypes.SUCCESS, message });
  }, []);

  const displayWarning = useCallback((message) => {
    dispatch({ type: messageTypes.WARNING, message });
  }, []);

  const displayError = useCallback((message) => {
    dispatch({ type: messageTypes.ERROR, message });
  }, []);

  const handleCloseSnackbar = () => {
    dispatch();
  };

  const messageContextValue = useMemo(
    () => ({
      displaySuccess,
      displayWarning,
      displayError,
    }),
    [displaySuccess, displayWarning, displayError],
  );

  const { settings: siteSettings } = site;
  let { socialNetworks } = siteSettings || {};

  if (socialNetworks && !Array.isArray(socialNetworks)) {
    socialNetworks = [socialNetworks];
  }

  return (
    <ThemeProvider theme={themes[site.name] || themes.ANTS}>
      <LanguageContextProvider>
        <PaginationContextProvider>
          <PageVersionContextProvider>
            <MessageContext.Provider value={messageContextValue}>
              <Snackbar {...snackbar} onClose={handleCloseSnackbar} />
              <LayoutFront>
                <FocusOnScroll />
                <Switch>
                  <Route path="/rechercher" component={ResultsSearch} />
                  <Route path="/">
                    <PageSwitcher />
                  </Route>
                </Switch>
              </LayoutFront>
            </MessageContext.Provider>
          </PageVersionContextProvider>
        </PaginationContextProvider>
      </LanguageContextProvider>
    </ThemeProvider>
  );
};

export default App;
